import styled from "styled-components";

export const ItemWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  display: flex;
  gap: 16px;
  padding: 16px 36px 16px 36px;

  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.hues.cetaceanShade1};
    color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
    transition: 0.3s ease all;

    svg {
      &:first-child {
        path {
          fill: ${({ theme }) => theme.colors.primary.cetaceanBlue};
        }
      }
    }

    > div:last-child {
      svg {
        path {
          fill: ${({ theme }) => theme.colors.neutral.white};
        }
      }
    }
  }
`;

export const Arrow = styled.button`
  height: 100%;
  flex: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1;

  svg {
    transition: 0.3s ease all;
    transform: rotate(${({ $active }) => ($active ? "0" : "-90deg")});
  }
`;

export const SubItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-left: 4px solid ${({ theme }) => theme.colors.neutral.white};
`;

export const SubItem = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  cursor: pointer;
  padding: 16px 36px 16px 36px;
  isolation: isolate;

  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};

  :hover {
    background-color: ${({ theme }) => theme.colors.hues.cetaceanShade1};
    color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
    transition: 0.3s ease all;
  }
`;
